import {Component, Input, OnInit, Output, EventEmitter} from '@angular/core';
import {ImageProperty} from '../../../user/model/ImageProperty';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {Dialog} from '../../../global/util/Dialog';
import {InformType} from '../../../global/util/enum/InformType';
import {Observable} from 'rxjs';

@Component({
  selector: 'app-add-image-property',
  templateUrl: './add-image-property.component.html',
  styleUrls: ['./add-image-property.component.css']
})
export class AddImagePropertyComponent implements OnInit {
  @Input() imageProperty: ImageProperty;
  selectedFile: any;
  // Envia una respuesta al padre.
  @Output() saveImage = new EventEmitter<string>();
  // @Input() events: Observable<void>;

  constructor(public activeModal: NgbActiveModal) {
  }

  ngOnInit(): void {
    console.log(this.imageProperty);
  }

  accept() {
    if (this.imageProperty.src) {
      // @ts-ignore
      this.saveImage.emit(this.imageProperty);
    } else {
      Dialog.show(InformType.Warning, 'Image properties', 'Image es required');
    }
  }

  changeStatus(event: Event) {
    const selectedFile = (event.target as HTMLInputElement).files[0];
    this.imageProperty.fileName = selectedFile.name;
    this.imageProperty.file = selectedFile;
    const reader = new FileReader();
    reader.onload = (e: any) => {
      const image = new Image();
      image.src = e.target.result;
      this.imageProperty.src = image.src;
    };
    reader.readAsDataURL((event.target as HTMLInputElement).files[0]);
  }

  cancel() {
    this.activeModal.close();
  }
}
